import {Component} from '@angular/core';

@Component({
  selector: 'kt-admin',
  template: '<router-outlet></router-outlet>'
})
export class AdminComponent {
  constructor() {

  }
}
